/*
 * NSE Compare (2026-10-29): compare up to 4 machines side by side as info cards.
 * - Product cards (snippets/card-product.liquid) and the Machine Library table have a Compare checkbox
 *   carrying the machine's data (snippets/nse-machine-json.liquid). Quote-only machines carry no price.
 * - The selection is kept in localStorage ("nse-compare-v1") so it follows the shopper across pages.
 * - A sticky bar shows the count with Compare / Clear. Compare opens a dialog of side-by-side cards
 *   (horizontal scroll on mobile, aligned spec rows, remove (x) per card).
 * API: window.NSECompare.{list, has, add, remove, toggle, clear, open, refresh}; event "nse-compare:change" on document.
 */
(function () {
  if (window.NSECompare) return;
  var KEY = 'nse-compare-v1';
  var MAX = 4;
  var TTL = 1000 * 60 * 60 * 24 * 14;

  function read() {
    try {
      var d = JSON.parse(localStorage.getItem(KEY) || '{}');
      if (!d || !Array.isArray(d.items)) return [];
      if (d.ts && Date.now() - d.ts > TTL) return [];
      return d.items.slice(0, MAX);
    } catch (e) { return []; }
  }
  function write(items) {
    try { localStorage.setItem(KEY, JSON.stringify({ ts: Date.now(), items: items.slice(0, MAX) })); } catch (e) {}
    document.dispatchEvent(new CustomEvent('nse-compare:change', { detail: { items: items.slice() } }));
  }
  function clean(m) {
    // keep only display fields; a quote-only machine never keeps a price
    var o = { id: m.id, h: m.h, u: m.u, t: m.t, b: m.b, c: m.c || [], l: m.l || '', w: m.w, a: m.a || [], f: m.f || '', buy: m.buy || '', q: !!m.q, p: m.q ? null : (m.p || null), i: m.i || '', il: m.il || m.i || '' };
    return o;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function fmtPower(w) {
    w = Number(w);
    if (!w) return '';
    if (w >= 1000) return (Math.round(w / 100) / 10).toString().replace(/\.0$/, '') + ' kW';
    return Math.round(w) + ' W';
  }

  var api = {
    MAX: MAX,
    list: read,
    has: function (id) { return read().some(function (m) { return String(m.id) === String(id); }); },
    add: function (m) {
      var items = read();
      if (items.some(function (x) { return String(x.id) === String(m.id); })) return true;
      if (items.length >= MAX) { toast('You can compare up to ' + MAX + ' machines. Remove one first.'); return false; }
      items.push(clean(m)); write(items); return true;
    },
    remove: function (id) { write(read().filter(function (m) { return String(m.id) !== String(id); })); },
    toggle: function (m, on) { if (on) return api.add(m); api.remove(m.id); return true; },
    clear: function () { write([]); },
    refresh: function (fresh) {
      // replace stored entries with fresh data (e.g. Machine Library just loaded current prices/quote status)
      var byId = {}; fresh.forEach(function (m) { byId[String(m.id)] = m; });
      var items = read(), changed = false;
      items = items.map(function (m) { var f = byId[String(m.id)]; if (f) { changed = true; return clean(f); } return m; });
      if (changed) write(items);
    },
    open: open,
    fmtPower: fmtPower,
    esc: esc
  };
  window.NSECompare = api;

  /* ---------- sticky bar ---------- */
  var bar, dlg, toastEl, toastT;
  function ensureBar() {
    if (bar) return bar;
    bar = document.createElement('div');
    bar.className = 'nse-cmp-bar';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Compare machines');
    bar.hidden = true;
    bar.innerHTML = '<div class="nse-cmp-bar__inner"><div class="nse-cmp-bar__thumbs" aria-hidden="true"></div><p class="nse-cmp-bar__count" aria-live="polite"></p>' +
      '<div class="nse-cmp-bar__btns"><button type="button" class="button nse-cmp-bar__go">Compare</button><button type="button" class="button button--secondary nse-cmp-bar__clear">Clear</button></div></div>';
    document.body.appendChild(bar);
    bar.querySelector('.nse-cmp-bar__go').addEventListener('click', open);
    bar.querySelector('.nse-cmp-bar__clear').addEventListener('click', function () { api.clear(); });
    return bar;
  }
  function renderBar() {
    ensureBar();
    var items = read();
    bar.hidden = items.length === 0;
    document.documentElement.classList.toggle('nse-cmp-has-bar', items.length > 0);
    bar.querySelector('.nse-cmp-bar__count').textContent = items.length + ' of ' + MAX + ' selected to compare';
    bar.querySelector('.nse-cmp-bar__thumbs').innerHTML = items.map(function (m) {
      return m.i ? '<img src="' + esc(m.i) + '" alt="" width="40" height="40" loading="lazy">' : '<span class="nse-cmp-bar__ph"></span>';
    }).join('');
    var go = bar.querySelector('.nse-cmp-bar__go');
    go.disabled = items.length < 2;
    go.title = items.length < 2 ? 'Pick at least 2 machines' : '';
  }
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'nse-cmp-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
  }

  /* ---------- compare dialog ---------- */
  var ROWS = [
    ['Brand', function (m) { return esc(m.b); }],
    ['Type', function (m) { return esc((m.c || []).join(', ')); }],
    ['Laser source', function (m) { return esc(m.l); }],
    ['Max power', function (m) { return esc(fmtPower(m.w)); }],
    ['Work area', function (m) { return esc((m.a || []).join(', ')); }],
    ['Format', function (m) { return esc(m.f); }],
    ['How to buy', function (m) { return esc(m.q ? 'Request a quote' : (m.buy || 'Buy online')); }],
    ['Price', function (m) { return m.q || !m.p ? '<span class="nse-cmp-quote">Request a quote</span>' : '<strong>' + esc(m.p) + '</strong>'; }]
  ];
  function ensureDlg() {
    if (dlg) return dlg;
    dlg = document.createElement('dialog');
    dlg.className = 'nse-cmp-dlg';
    dlg.setAttribute('aria-labelledby', 'nse-cmp-title');
    dlg.innerHTML = '<div class="nse-cmp-dlg__inner"><div class="nse-cmp-dlg__head"><h2 id="nse-cmp-title" class="h3">Compare machines</h2>' +
      '<button type="button" class="nse-cmp-dlg__close" aria-label="Close compare">&times;</button></div>' +
      '<div class="nse-cmp-grid-wrap"><div class="nse-cmp-grid"></div></div>' +
      '<p class="nse-cmp-dlg__foot"><a class="link" href="/pages/machine-library">Open the Machine Library</a></p></div>';
    document.body.appendChild(dlg);
    dlg.querySelector('.nse-cmp-dlg__close').addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg) dlg.close();
      var rm = e.target.closest('[data-cmp-remove]');
      if (rm) { api.remove(rm.getAttribute('data-cmp-remove')); if (read().length === 0) dlg.close(); }
    });
    dlg.addEventListener('close', function () { document.documentElement.classList.remove('nse-cmp-open'); });
    return dlg;
  }
  function renderDlg() {
    if (!dlg) return;
    var items = read();
    var g = dlg.querySelector('.nse-cmp-grid');
    g.style.setProperty('--n', Math.max(items.length, 1));
    // row-major grid: one column per machine, so every spec row lines up across the cards
    var html = '';
    items.forEach(function (m) {
      html += '<div class="nse-cmp-cell nse-cmp-cell--top">' +
        '<button type="button" class="nse-cmp-x" data-cmp-remove="' + esc(m.id) + '" aria-label="Remove ' + esc(m.t) + ' from compare">&times;</button>' +
        '<a class="nse-cmp-img" href="' + esc(m.u) + '">' + (m.il ? '<img src="' + esc(m.il) + '" alt="' + esc(m.t) + '" loading="lazy">' : '<span class="nse-cmp-ph">No photo</span>') + '</a>' +
        '<p class="nse-cmp-brand">' + esc(m.b) + '</p><h3 class="nse-cmp-model"><a href="' + esc(m.u) + '">' + esc(m.t) + '</a></h3></div>';
    });
    ROWS.forEach(function (r, ri) {
      items.forEach(function (m) {
        var v = r[1](m);
        html += '<div class="nse-cmp-cell' + (ri === ROWS.length - 1 ? ' nse-cmp-cell--last' : '') + '"><span class="nse-cmp-k">' + r[0] + '</span><span class="nse-cmp-v">' + (v || '<span class="nse-cmp-na">–</span>') + '</span></div>';
      });
    });
    items.forEach(function (m) {
      html += '<div class="nse-cmp-cell nse-cmp-cell--cta"><a class="button button--full-width' + (m.q ? ' button--secondary' : '') + '" href="' + esc(m.u) + (m.q ? '#request-quote' : '') + '">' + (m.q ? 'Request a quote' : 'View machine') + '</a></div>';
    });
    g.innerHTML = items.length ? html : '<p class="nse-cmp-emptymsg">Nothing selected yet. Tick Compare on up to ' + MAX + ' machines.</p>';
  }
  function open() {
    ensureDlg();
    renderDlg();
    document.documentElement.classList.add('nse-cmp-open');
    if (!dlg.open) { if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', ''); }
  }

  /* ---------- checkboxes (product cards + library) ---------- */
  function syncBoxes(root) {
    (root || document).querySelectorAll('input.nse-cmp-cb').forEach(function (cb) {
      var id = cb.getAttribute('data-id');
      cb.checked = api.has(id);
    });
  }
  document.addEventListener('change', function (e) {
    var cb = e.target;
    if (!cb.matches || !cb.matches('input.nse-cmp-cb')) return;
    var m;
    if (cb._nseMachine) m = cb._nseMachine;
    else { try { m = JSON.parse(cb.getAttribute('data-machine')); } catch (err) { m = null; } }
    if (!m) return;
    var ok = api.toggle(m, cb.checked);
    if (!ok) cb.checked = false;
  });
  // keep clicks on the card checkbox from following the card link
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.nse-cmp-toggle')) e.stopPropagation();
  }, true);

  document.addEventListener('nse-compare:change', function () { renderBar(); syncBoxes(); if (dlg && dlg.open) renderDlg(); });
  window.addEventListener('storage', function (e) { if (e.key === KEY) { renderBar(); syncBoxes(); if (dlg && dlg.open) renderDlg(); } });
  window.addEventListener('pageshow', function () { renderBar(); syncBoxes(); });
  // product grids that re-render (filters, infinite scroll, search) get re-synced
  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) { if (muts[i].addedNodes.length) { syncBoxes(); break; } }
  });
  function init() {
    renderBar(); syncBoxes();
    mo.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
